module.exports = __webpack_public_path__ + "static/media/edit_box.e2f584ea.svg";